module.exports = __webpack_public_path__ + "img/153.8796e119.jpg";